module.exports = __webpack_public_path__ + "media/images/flags/16/Turkmenistan-a664bd144253ed3b3a58865b740559fb.png";